<template>
  <ArticleDetails
    :title="title"
    :editable="editable"
    :media="media"
    :content="content"
    :articleId="articleId"
    :newLinkParagraphId="newLinkParagraphId"
    :newLinkWordsIndexes="newLinkWordsIndexes"
    @reload_current_article="reloadArticleData"
  ></ArticleDetails>
</template>

<script>
import ArticleDetails from "./details.vue";

export default {
  name: "Article",
  props: {
    articleIdFromParent: {
      default: null,
      type: Number,
    },
  },
  data() {
    let articleId = Number(this.$route.params.id);
    if (this.articleIdFromParent !== null) {
      articleId = Number(this.articleIdFromParent);
    }
    return {
      articleId: articleId,
      title: null,
      editable: false,
      media: null,
      content: null,
      newLinkParagraphId: null,
      newLinkWordsIndexes: [],
    };
  },
  methods: {
    loadArticleData(articleId) {
      this.$http.get("articles/" + articleId + "/").then(
        (response) => {
          let articleData = response.body;
          this.title = articleData.title;
          this.editable = articleData.editable;
          if (articleData.content !== null) {
            this.content = articleData.content;
          } else {
            this.content = null;
          }
          if (articleData.media !== null) {
            this.media = articleData.media.data;
          } else {
            this.media = null;
          }
        },
        (errors) => {
          console.log(errors);
        }
      );
    },
    reloadArticleData(newLinkData) {
      this.loadArticleData(this.articleId);
      this.newLinkParagraphId = newLinkData.newLinkParagraphId;
      this.newLinkWordsIndexes = newLinkData.newLinkWordsIndexes;
    },
  },
  components: {
    ArticleDetails,
  },
  watch: {
    $route(to, from) {
      from;
      this.articleId = Number(to.params.id);
      this.loadArticleData(this.articleId);
    },
  },
  created() {
    this.loadArticleData(this.articleId);
  },
};
</script>

<style scoped></style>
